/* eslint-disable no-useless-escape */
import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../Core/redux/hooks";
import { Dropdown, Tooltip } from "antd";
import { updateConversations } from "../../Core/redux/slices/conversations.slice";
import { downloadFiles } from "../../Core/utils";

// import Album from "../../Core/Common/Album";
import dayjs from "dayjs";
import CustomAvatar from "../../Core/Common/CustomAvatar";
import UserDetailsCard from "./UserDetailsCard";
import ParseMentions from "./ParseMentions";
import { EmojiIcon } from "../../Core/svgV2/EmojiIcon";

import { DownloadIcon } from "../../Core/svgV2/DownloadIcon";

import { EditIcon } from "../../Core/svgV2/EditIcon";

//todo add typescript validation
export const Thumbnail = ({
  type = "",
  url,
  className = "max-w-[200px] overflow-hidden h-auto",
  file,
}) => {
  const [isHover, setIsHover] = useState(false);
  let body = <></>;
  if (type.includes("video")) {
    body = (
      <div className={`${className} flex flex-col bg-white rounded-[12px]`}>
        {/* <div className="flex flex-col bg-white rounded-sm "> */}
        <div className=" h-[130px] rounded-[8px] my-[8px] mx-[8px] overflow-hidden">
          <video
            className=" h-[130px]"
            muted
            autoPlay={false}
            controls
            preload="metadata"
          //poster={thumbnail}
          >
            <source src={`${url}#t=0.1`}></source>
          </video>
        </div>
        <div
          className="flex flex-row mb-[8px] mx-[8px] justify-between "
          onMouseEnter={() => {
            setIsHover(true);
          }}
          onMouseLeave={() => setIsHover(false)}
        >
          <div className="flex flex-row  text-gray-700 gap-x-[8px] out-500-12 items-end h-[20px] w-[155px] ">
            <img src={"/images/v2/conversations/Video.svg"}></img>First draft of
            ideas.mp4
          </div>
          <div className="">
            {isHover ? <DownloadIcon className="out-500-12" /> : ""}
          </div>
        </div>
      </div>
    );
  } else if (type == "image") {
    body = (
      <div className={`${className} flex flex-col bg-white rounded-[12px]`}>
        <div className=" h-[130px] rounded-[8px] my-[8px] mx-[8px] overflow-hidden">
          <img src={"/images/v2/conversations/ImagePreview.svg"} />
        </div>
        <div
          className="flex flex-row mb-[8px] mx-[8px] justify-between "
          onMouseEnter={() => {
            setIsHover(true);
          }}
          onMouseLeave={() => setIsHover(false)}
        >
          <div className="flex flex-row  text-gray-700 gap-x-[8px] out-500-12 items-end h-[20px] w-[155px] ">
            <img src={"/images/v2/conversations/imageIcon.svg"}></img>First
            draft of ideas.jpg
          </div>
          <div className="">
            {isHover ? <DownloadIcon className="out-500-12" /> : ""}
          </div>
        </div>
      </div>
    );
  } else {
    body = (
      <div className={`${className} flex flex-col bg-white rounded-[12px]`}>
        <div className="rounded-[8px] my-[8px] mx-[8px] overflow-hidden">
          <img src={"/images/v2/conversations/ImagePreview.svg"} />
        </div>
        <div
          className="flex flex-row mb-[8px] mx-[8px] justify-between "
          onMouseEnter={() => {
            setIsHover(true);
            console.log("hovering");
          }}
          onMouseLeave={() => setIsHover(false)}
        >
          <div className="flex flex-row   text-gray-700 gap-x-[8px] out-500-12 items-end h-[20px] w-[155px] ">
            <img src={"/images/v2/conversations/pdf.svg"}></img>
            <p className="whitespace-nowrap truncate"> {file.name}</p>
          </div>
          <div className="">
            {isHover ? (
              <button
                onClick={() => {
                  downloadFiles([url], file.fileSize);
                }}
              >
                <DownloadIcon className="out-500-12" />
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
  return body;
};

const Album = ({ message, files }) => {
  // TODO: like image array make this for video and other file
  const images = files.filter((file) => file.type?.includes("png")) || [];
  let imageArray = <></>;
  if (images.length > 0) {
    imageArray = (
      <div className="flex flex-col  gap-y-3 mt-1">
        {images.map((img, i) => (
          <div
            key={i}
            className="max-h-[100px] max-w-[147px] min-h-[100px] min-w-[147px] rounded-lg border flex justify-center items-center border-gray-200"
          >
            <img
              className="max-h-[100px] max-w-[147px] object-cover "
              src={img.url}
            />
          </div>
        ))}
      </div>
    );
  }
  const otherFiles = files.filter((file) => !file.type?.includes("png")) || [];
  let filesArray = <></>;
  if (otherFiles.length > 0) {
    filesArray = (
      <div className="flex flex-col gap-y-3 mt-1">
        {otherFiles.slice(0, 5).map((img, i) => (
          <div key={i}>
            <Thumbnail type={img.type} url={img.url} file={img} />
          </div>
        ))}
      </div>
    );
  }
  return (
    <div className="pb-1">
      {imageArray}
      <div className="">{filesArray}</div>
    </div>
  );
};

const QuickChatMessage = ({
  message,
  reactToMessage,
  allowHover = true,
  showSender = true,
}: {
  message: any;
  comments?: boolean;
  allowHover?: boolean;
  reactToMessage?: (
    emoji: string,
    messageId: string,
    isAlreadyReacted: boolean
  ) => void;
  handleMarkAsUnread?: (message: object) => void;
  deleteMessage?: (id: string) => void;
  showSender?: boolean;
}) => {
  const { tenantMembers } = useAppSelector((state) => state.tenant);
  const { user } = useAppSelector((state) => state.userDetails);
  const dispatch = useAppDispatch();

  // NEW — needed to tell sent vs received bubbles apart
  const isOwn = (message.senderId ?? message.sender) == user.id;

  const isAlreadyReacted = (emoji) =>
    message.reactions &&
    message.reactions[emoji] &&
    message.reactions[emoji].includes(user.id);

  const reactionOverLay = (
    <div className="flex bg-white shadow-bottom items-center rounded-full h-[40px]">
      <button className="w-5 h-5 mx-3" onClick={() => reactToMessage("😊", message._id, isAlreadyReacted("😊"))}>
        <span className="text-xl w-5 h-5">😊</span>
      </button>
      <button className="w-5 h-5 mx-3" onClick={() => reactToMessage("😆", message._id, isAlreadyReacted("😆"))}>
        <span className="text-xl">😆</span>
      </button>
      <button className="w-5 h-5 mx-3" onClick={() => reactToMessage("❤️", message._id, isAlreadyReacted("❤️"))}>
        <span className="text-xl">❤️</span>
      </button>
      <button className="w-5 h-5 mx-3" onClick={() => reactToMessage("👍", message._id, isAlreadyReacted("👍"))}>
        <span className="text-xl">👍</span>
      </button>
      <button className="w-5 h-5 mx-3" onClick={() => reactToMessage("👎", message._id, isAlreadyReacted("👎"))}>
        <span className="text-xl">👎</span>
      </button>
      <button className="w-5 h-5 mx-3" onClick={() => reactToMessage("👌", message._id, isAlreadyReacted("👌"))}>
        <span className="text-xl">👌</span>
      </button>
    </div>
  );

  const getHoverMenu = () => (
    <div
      className={`bg-white ${allowHover ? "hidden group-hover:flex" : "flex"} absolute top-1 ${isOwn ? "left-1" : "right-1"} h-9 border border-gray-100 justify-around items-center rounded-[4px] w-[64px]`}
    >
      <Dropdown trigger={["click"]} overlay={reactionOverLay}>
        <Tooltip title="Add reaction">
          <button>
            <EmojiIcon />
          </button>
        </Tooltip>
      </Dropdown>
      <Tooltip title="Edit Comment">
        <button
          onClick={() =>
            dispatch(updateConversations({ key: "editMessage", value: { edit: true, messageObject: message } }))
          }
        >
          <EditIcon className="text-black" />
        </button>
      </Tooltip>
    </div>
  );

  const getAttachements = (attachments) => {
    if (attachments.length === 0) return;
    const newAttacments = attachments.map((attachment) => ({ ...attachment, messageId: message._id }));
    return <Album files={newAttacments} message={message} />;
  };

  const senderProfilePicture = tenantMembers.find((t) => t.id == message.senderId)?.profilePicture;

  return (
    <div
      className={`px-4 py-0.5 scroll-mt-[20vh] relative ${allowHover ? "group" : ""}`}
      data-message-id={message._id}
    >
      <div className={`flex ${isOwn ? "justify-end" : "justify-start"}`}>
        <div className={`flex flex-col max-w-[380px] ${isOwn ? "items-end" : "items-start"}`}>

          {/* ── Bubble ── */}
          <div
            className={`relative w-full min-w-[216px] px-3 py-2 border transition-all duration-100 ease-out
              ${isOwn
                ? "bg-primary-600 border-primary-600 text-white rounded-[12px] rounded-tr-[2px]"
                : "bg-white border-gray-200 text-gray-900 rounded-[12px] rounded-tl-[2px]"
              }`}
          >
            {getHoverMenu()}

            <div className="flex items-center gap-x-1.5 mb-1 min-w-0">
              {showSender ? (
                <CustomAvatar title={message.senderName} size={22} src={senderProfilePicture} className="flex-shrink-0" whiteText />
              ) : null}

              {showSender && (
                <div className={`min-w-0 flex-shrink overflow-hidden ${isOwn ? "[&_*]:!text-white" : ""}`}>
                  <UserDetailsCard userName={isOwn ? "You" : message.senderName} isDisable={false} userId={message.senderId} className="truncate" />
                </div>
              )}

              {message.request?.type && (
                <img src="/images/v2/conversations/AttachmentHeader.svg" className="w-[26px] h-5 flex-shrink-0" />
              )}

              <Tooltip title={message.createdAt ? dayjs(message.createdAt).utc().local().format("MMMM DD YYYY, hh:mm a") : "-"}>
                <div className={`out-300-10 flex-shrink-0 whitespace-nowrap ${isOwn ? "text-white/60" : "text-gray-400"}`}>
                  {message.createdAt ? dayjs(message.createdAt).utc().local().format("hh:mm a") : "-"}
                </div>
              </Tooltip>
            </div>

            {message.replyMessage && message.replyMessage._id && (
              <div className={`flex mb-2 rounded-[4px] p-1.5 items-start ${isOwn ? "bg-primary-700" : "bg-gray-50 border border-gray-200"}`}>
                <img src="/images/v2/conversations/message-reply-2.svg" className="w-3 h-3 mt-0.5 flex-shrink-0" />
                <div className="ml-1.5 min-w-0">
                  <div className={`out-500-12 capitalize truncate ${isOwn ? "text-gray-200" : "text-gray-400"}`}>
                    {message.replyMessage.senderName}
                  </div>
                  <div className={`mt-0.5 ${isOwn ? "[&_*]:!text-gray-200" : ""}`}>
                    <ParseMentions value={message.replyMessage.message} className={`out-300-12 ${isOwn ? "text-gray-200" : "text-gray-500"}`} />
                  </div>
                </div>
              </div>
            )}

            <div className={isOwn ? "[&_*]:!text-white" : "[&_*]:!text-gray-900"}>
              <ParseMentions value={message.message} textClassName="out-300-14" />
            </div>

            {message.attachments && <div className="mt-1">{getAttachements(message.attachments)}</div>}
          </div>

          {/* ── Reactions (below bubble) ── */}
          {message.reactions && Object.keys(message.reactions).some((e) => message.reactions[e]?.length > 0) && (
            <div className={`flex items-center flex-wrap gap-x-1.5 gap-y-1 mt-1 ${isOwn ? "justify-end" : "justify-start"}`}>
              {Object.keys(message.reactions).map(
                (emoji, index) =>
                  message.reactions[emoji].length > 0 && (
                    <button
                      className="flex items-center"
                      key={index}
                      onClick={() => reactToMessage(emoji, message._id, message.reactions[emoji].includes(user.id))}
                    >
                      <div className="flex items-center py-0.5 px-2 h-6 bg-white rounded-2xl border border-gray-200 shadow-xs">
                        <span className="text-base leading-none">{emoji}</span>
                        {message.reactions[emoji].length > 1 && (
                          <span className="pl-1 out-500-12 text-gray-700">{message.reactions[emoji].length}</span>
                        )}
                      </div>
                    </button>
                  )
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const Day = ({ date }) => {
  const formateDate = (date) => {
    if (date === null || typeof date === "undefined") return "-";
    if (dayjs(date).isToday()) return "Today";
    if (dayjs(date).isTomorrow()) return "Tomorrow";
    return dayjs(date).format("MMMM DD YYYY");
  };
  return (
    <div className="px-[10px] py-[5px] mx-auto my-1 border w-max shadow-xs rounded-[4px] border-gray-200">
      <p className="out-300-14 text-gray-700">{formateDate(date)}</p>
    </div>
  );
};

export const Unread = ({ type, count }) => {
  return (
    <div className="out-500-14 bg-error-50 my-1 text-error-500 text-center w-full ">
      {count} New messages
    </div>
  );
};

export function TypingIndicator({
  typingStatus,
  currentThread,
  // reactToMessage,
  // deleteMessage,
}) {
  // const [isTyping, setIsTyping] = useState(false);
  const isPrivateThread = currentThread.type === "private";
  const isMatchingUser = +typingStatus.userId === +currentThread.userId;
  const isMatchingThread = +typingStatus.threadId === +currentThread.threadId;

  // useEffect(() => {
  //   console.log(isTyping, typingStatus.isTyping, "typingStatus");
  //   if (typingStatus.isTyping) {
  //     setIsTyping(typingStatus.isTyping);
  //   }
  //   if (!typingStatus.isTyping) {
  //     setTimeout(() => {
  //       if (!typingStatus.isTyping) {
  //         setIsTyping(typingStatus.isTyping);
  //       }
  //     }, 5000);
  //   }
  // }, [typingStatus]);

  if (
    !typingStatus.isTyping ||
    (isPrivateThread ? !isMatchingUser : !isMatchingThread)
  ) {
    return <></>;
  }

  if (currentThread.type !== typingStatus.threadType) {
    return <></>;
  }

  return (
    <div className="pl-24 mt-1.5 mb-0 flex items-center">
      <div className="dot-collision" />

      <span className="ml-7 mon-500-10 italic text-gray-500">
        {currentThread.type === "group"
          ? typingStatus.userName + " " + "is"
          : ""}{" "}
        Typing.....
      </span>
    </div>
  );
}

export default QuickChatMessage;
